
// export const environment = {
//     baseURL: 'https://az-api-unity-gateway-dev.azurewebsites.net/IntegrationService/api/v1',
//     baseURLV2: 'https://az-api-unity-gateway-dev.azurewebsites.net/TenantService/api/v2',
//     baseURLINT: 'https://az-api-unity-gateway-dev.azurewebsites.net/IntegrationService/api/v2'
// };

export const environment = {
    baseURL: 'https://gateway.unitydev.ca/IntegrationService/api/v1',
    baseURLV2: 'https://gateway.unitydev.ca/TenantService/api/v2',
    baseURLINT: 'https://gateway.unitydev.ca/IntegrationService/api/v2'
};
